var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 8.50002H20.4L19 1.50002C19 1.30002 18.9 1.20002 18.7 1.00002C18.5 1.00002 18.3 1.00002 18.1 1.00002C17.9 1.00002 17.8 1.20002 17.7 1.30002C17.6 1.50002 17.6 1.60002 17.6 1.80002L19 8.50002H5.00001L6.40001 1.80002C6.50001 1.40002 6.20001 1.10002 5.90001 1.00002C5.50001 0.900023 5.10001 1.20002 5.00001 1.50002L3.60001 8.50002H1.90001C1.30001 8.50002 0.700012 9.00002 0.700012 9.70002V11.8C0.700012 12.5 1.20001 13 1.90001 13H2.40001L4.50001 22.1C4.60001 22.6 5.10001 23 5.70001 23H18.3C18.9 23 19.3 22.6 19.5 22.1L21.6 13H22.1C22.8 13 23.3 12.5 23.3 11.8V9.70002C23.3 9.00002 22.7 8.50002 22.1 8.50002ZM18.2 21.6H5.80001L3.80001 13H20L18.2 21.6ZM21.8 11.6H2.20001V9.90002H21.9V11.6H21.8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 15.5V19.4C9.9 19.8 9.6 20.1 9.2 20.1C8.8 20.1 8.5 19.8 8.5 19.4V15.5C8.5 15.1 8.8 14.8 9.2 14.8C9.6 14.7 9.9 15.1 9.9 15.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5V19.4C15.5 19.8 15.2 20.1 14.8 20.1C14.4 20.1 14.1 19.8 14.1 19.4V15.5C14.1 15.1 14.4 14.8 14.8 14.8C15.2 14.7 15.5 15.1 15.5 15.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.efa2851a.svg";
export { ForwardRef as ReactComponent };